module.exports = __webpack_public_path__ + "img/1.10011d11.jpg";